export class Step4 {
    constructor() { }
    intitule = 'stepper.form.simp_re.step4';
    getobjet = 'form.simp_re.getobjet';
    getspan2 = 'form.simp_re.getspan2';
    getspan3 = 'form.simp_re.getspan3';
    getclassprincipale = 'form.simp_re.getclassprincipale';
    getclasssupplementaire = 'form.simp_re.getclasssupplementaire_liste_avi_';
    getobjetprincipal = 'form.simp_re.getobjetprincipal';
    getobjetcomplementaire = 'form.simp_re.getobjetcomplementaire';
    gettypemarche = 'form.simp_re.gettypemarche';
    getspan5 = 'form.simp_re.getspan5';
    getnum = 'form.simp_re.getnum';
    gettypevoie = 'form.simp_re.gettypevoie';
    getnomvoie = 'form.simp_re.getnomvoie';
    getcp = 'form.simp_re.getcp';
    getville = 'form.simp_re.getville';
    getintitule = 'form.simp_re.getintitule';
    getdescription = 'form.simp_re.getdescription';
    gettravaux = 'form.simp_re.gettravaux';
    getfournitures = 'form.simp_re.getfournitures';
    getservices = 'form.simp_re.getservices';
    getlieuexecutionlivraison = 'form.simp_re.getlieuexecutionlivraison';
    getmotclef = 'form.simp_re.getmotclef_liste_avi_';
    ajouter = 'boutons.ajouter';
    supprimer = 'boutons.supprimer';
}
